// extracted by mini-css-extract-plugin
export default {"main":"uca-z"};